﻿
import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAvalAuftrag extends GuiListGeneric {

    constructor() {
        super("GuiListAvalAuftrag");

    }

}
